import { BookOpen, GraduationCap, CheckCircle, FileText, Bell } from 'lucide-react';

export const dayOne = [
    {
      time: "08:30–09:00",
      session: "Registration & Welcome",
      facilitators: "Prof. David Dodoo-Arhin",
      description: "Opening remarks and workshop overview",
    },
    {
      time: "09:00–10:00",
      session: "Keynote Lecture: Frontiers in Nanomaterials for Energy",
      facilitators: "Prof. Petra Rudolf",
      description: "Advances in 2D materials and hybrid systems for energy conversion",
    },
    {
      time: "10:00–10:30",
      session: "Coffee Break",
      facilitators: "—",
      description: "Refreshment and Networking",
    },
    {
      time: "10:30–12:00",
      session: "Session 1:Perovskite and Hybrid Solar Materials",
      facilitators: "Prof. Maria Antonietta Loi & Prof. LJA Koster",
      description: "Photophysics, device architecture, and performance optimization",
    },
    {
      time: "12:00–13:00",
      session: "Lunch",
      facilitators: "—",
      description: "-",
    },
    {
      time: "13:00–14:30",
      session: "Hands-on Workshop 1: Solar Cell Fabrication & Testing",
      facilitators: "Prof. Loi, Dr. Nana Ama Asantewaa",
      description: "Lab-based session on assembling and characterizing solar cells",
    },
    {
      time: "14:30–15:00",
      session: "Break",
      facilitators: "—",
      description: "-",
    },
    {
      time: "15:00–16:30",
      session: "Session 2:Battery Materials & Electrochemical Storage",
      facilitators: "Prof. Monika Tromp, Prof. Guiseppe Portale",
      description: "Operando spectroscopy and materials for sustainable batteries",
    },
    {
      time: "16:30–17:00",
      session: "Reflections & Wrap-up",
      facilitators: "Prof. Dodoo-Arhin",
      description: "Summary and Q&A",
    },
  ];

  export const dayTwo = [
    {
      time: "08:30–10:00",
      session: "Session 3: Waste-to-Energy & Circular Materials",
      facilitators: "Dr. Tesfaye Alemu & Dr. Koenraad Van Acker",
      description: "Case studies and technologies for African contexts",
    },
    {
      time: "10:00–10:30",
      session: "Coffee Break",
      facilitators: "—",
      description: "—",
    },
    {
      time: "10:30–12:00",
      session: "Session 4: Life Cycle Assessment & Policy Mapping",
      facilitators: "Dr. Grace Wambui & Dr. Emmanuel Essel",
      description: "Tools for evaluating sustainability and policy integration",
    },
  ];

export const sections = [
    { id: 'overview', label: 'General information', icon: BookOpen},
    { id: 'notice', label: 'Important Notice', icon: Bell },
    { id: 'requirements', label: 'Requirements', icon: CheckCircle },
    { id: 'content', label: 'Course Content', icon: FileText },
    { id: 'outcomes', label: 'Learning Outcomes', icon: GraduationCap },
    { id: 'schedule', label: 'Schedule of events', icon: FileText},
    { id: 'application', label: 'Application Procedure', icon: FileText }
  ];